import * as React from "react";
const SvgDataflow02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 20a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0M4 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0m18 0a3 3 0 0 1-5.826 1H13v6h3.174A2.998 2.998 0 0 1 22 12a3 3 0 0 1-5.826 1H13v2.2c0 .857 0 1.439.037 1.889.036.438.101.663.18.82a2 2 0 0 0 .875.873c.156.08.38.145.82.18.33.028.732.033 1.263.035A2.998 2.998 0 0 1 22 20a3 3 0 0 1-5.827.997 19 19 0 0 1-1.425-.04c-.562-.047-1.08-.145-1.564-.393a4 4 0 0 1-1.748-1.748c-.248-.485-.346-1.002-.392-1.564-.045-.55-.044-1.228-.044-2.052V5H7.826A2.999 2.999 0 0 1 2 4a3 3 0 0 1 5.826-1h8.348A2.998 2.998 0 0 1 22 4"
}));
export default SvgDataflow02;
//# sourceMappingURL=Dataflow02.js.map